import { ImpulseElement, registerElement, target, targets } from '@ambiki/impulse';
import type PatientAttendanceElement from './patient_attendance_element';
import type PatientCheckinElement from './patient_checkin_element';

@registerElement('patient-list')
export default class PatientListElement extends ImpulseElement {
  @target() attendance: PatientAttendanceElement;
  @target() checkin?: PatientCheckinElement;
  @targets() checkboxes: HTMLInputElement[];

  /**
   * Called when the element is connected to the DOM.
   */
  connected() {
    this.toggleState();
  }

  /**
   * Called when the patient checkboxes are changed.
   */
  toggleState() {
    this.attendance.selectedPatientIds = this.patientIds;
    this.attendance.active = !this.isUnchecked;

    if (!this.checkin) return;
    this.checkin.selectedPatientIds = this.patientIds;
    this.checkin.active = !this.isUnchecked;
  }

  private get isUnchecked(): boolean {
    return this.checkboxes.every((c) => !c.checked);
  }

  private get patientIds(): string[] {
    return this.checkedCheckboxes.map((c) => c.value).filter(Boolean);
  }

  private get checkedCheckboxes(): HTMLInputElement[] {
    return this.checkboxes.filter(({ checked }) => checked);
  }
}
